module.exports = __webpack_public_path__ + "04_short_black.91d2c12d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_short_black.png
// module id = vS0Y
// module chunks = 0